import { get } from 'svelte/store';
import { SpotifyClient } from '../../lib/spotify/SpotifyClient';
import { notifications } from '../../stores/notifications';
import { shortcuts } from '../../stores/rooster';
import { spotifyPlayerState } from '../../stores/spotify';
import { createCommaArray } from '../../utils/utils';
import { refershOrGetOAuthToken, device_id } from './login';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import '../../stores/globalState';
import 'cluster';
import { pulse } from '../../components/sections/FloatingBlobs/flobs';
momentDurationFormatSetup(moment);
async function loadSearch(query, type) {
    var _a, _b;
    let toQueue = false;
    let res;
    if (!query || query.length < 2)
        return {};
    const seachTy = type === 'search' ? ['album', 'track', 'artist'] : [type];
    // @ts-ignore
    if (!res) {
        res = await SpotifyClient.search(query, seachTy, { limit: type === 'search' ? 4 : 8 })
            .catch((e) => { if (e.status === 401)
            refershOrGetOAuthToken(); });
    }
    let examples = {};
    if (!res)
        return examples; //return immediately if no result was found
    let exampleList = [];
    for (const key of (Object.keys(res))) {
        let mostPopularArtist;
        if (key === 'artists') {
            res.artists.items.sort((a, b) => b.popularity - a.popularity);
            mostPopularArtist = res.artists.items[0].uri;
        }
        if ((_b = (_a = res[key]) === null || _a === void 0 ? void 0 : _a.items[0]) === null || _b === void 0 ? void 0 : _b.popularity)
            res[key].items = res[key].items.sort((a, b) => b.popularity > a.popularity);
        const list = res[key].items.map((item) => {
            var _a, _b, _c;
            let tip = '';
            let size = 'sm';
            if (key === 'tracks') {
                tip += item.explicit ? '[E] ' : ' ';
                tip += createCommaArray(item.artists.map(a => a.name));
                //@ts-ignore
                tip += ' · ' + moment.duration(item.duration_ms, 'milliseconds').format('mm:ss', { trim: false });
            }
            else if (key === 'artists') {
                tip = '[Artist' + (mostPopularArtist === item.uri ? ', most popular' : '') + ']';
                size = mostPopularArtist === item.uri ? 'md' : 'sm';
            }
            else if (key === 'albums') {
                tip = `[Album${item.release_date ? (' - ' + item.release_date) : ''}]`;
            }
            else if (key === 'playlists') {
                if ((_a = item === null || item === void 0 ? void 0 : item.owner) === null || _a === void 0 ? void 0 : _a.display_name)
                    tip = 'by ' + ((_b = item === null || item === void 0 ? void 0 : item.owner) === null || _b === void 0 ? void 0 : _b.display_name);
            }
            const images = ((_c = item === null || item === void 0 ? void 0 : item.album) === null || _c === void 0 ? void 0 : _c.images) ? item.album.images : item.images;
            const image = images.length ? images[images.length - 1].url : '';
            return {
                'example': item.name,
                tip,
                image,
                'selectable': true,
                'id': (toQueue !== false ? `${toQueue}>>${item.name}<<` : '') + item.uri,
                size,
                sortingKey: item.popularity
            };
        });
        exampleList.push(...list);
    }
    examples.group = exampleList;
    examples.namespace = type;
    examples.tips = { '0': '播放', '1': '添加到队列', '2': '播放但保留队列' };
    return examples;
}
async function loadQueue() {
    var _a;
    const playerState = get(spotifyPlayerState);
    if ((_a = playerState.track_window) === null || _a === void 0 ? void 0 : _a.next_tracks.length) {
        return {
            'namespace': '队列',
            'group': playerState.track_window.next_tracks.map((el, i) => {
                var _a, _b;
                return {
                    'argument': '#' + (i + 1).toString(),
                    'example': el.name,
                    'selectable': false,
                    'size': 'sm',
                    'image': ((_b = (_a = el === null || el === void 0 ? void 0 : el.album) === null || _a === void 0 ? void 0 : _a.images[0]) === null || _b === void 0 ? void 0 : _b.url) || '',
                };
            })
        };
    }
    else {
        return { 'group': [], 'namespace': '队列' };
    }
}
async function loadPodcastSearch(query) {
    if (!query || query.length < 2)
        return {};
    const { shows } = await SpotifyClient.searchShows(query, { limit: 10 });
    console.log(shows);
    let group = [];
    for (let i = 0; i < shows.items.length; i++) {
        const show = shows.items[i];
        group.push({
            example: show.name,
            //@ts-ignore
            tip: `${show.explicit ? '[E]' : ''} ${show.publisher} - ${show.total_episodes ? `${show.total_episodes} episodes` : ''}`,
            image: show.images[0].url,
            id: show.id,
            selectable: true,
            size: 'sm',
            sortingKey: (-i)
        });
    }
    const examples = { namespace: '播客', group, tips: { 0: '播放', 1: '选择一集' } };
    return examples;
}
let selectedShowId = '';
let lastLoadedEpisodes;
let lastLoadedShow;
async function loadEpisodeSearch(q = undefined) {
    if (!selectedShowId.length)
        return {};
    if (!lastLoadedShow || lastLoadedShow.id !== selectedShowId || !lastLoadedEpisodes) {
        lastLoadedShow = await SpotifyClient.getShow(selectedShowId);
        lastLoadedEpisodes = await SpotifyClient.getShowEpisodes(selectedShowId, { limit: 50, q });
    }
    let episodes = [];
    if (q) {
        q = q.trim();
        episodes = lastLoadedEpisodes.items.filter(ep => ep.name.match(new RegExp(q, 'i')));
    }
    else {
        episodes = lastLoadedEpisodes.items;
    }
    let group = [];
    for (let i = 0; i < (episodes.length > 20 ? 20 : episodes.length); i++) {
        const episode = episodes[i];
        group.push({
            example: episode.name,
            //@ts-ignore
            tip: `${episode.explicit ? '[E]' : ''} ${lastLoadedShow.publisher} - ${moment.duration(episode.duration_ms).format('mm:ss', { trim: false })} - ${episode.release_date}`,
            image: episode.images[0].url,
            id: episode.uri,
            selectable: true,
            size: 'sm',
            sortingKey: (-i),
        });
    }
    const examples = { namespace: lastLoadedShow.name + ' 的剧集', group, tips: { 0: '播放' } };
    return examples;
}
export function createShortcuts() {
    let args = {};
    ['search', 'album', 'playlist', 'track'].forEach(el => {
        args[el] = {
            description: `在 Spotify 上搜索 ${el === 'search' ? '所有内容' : el === 'album' ? '专辑' : el === 'playlist' ? '播放列表' : '曲目'}`,
            async callback(p, id, action) {
                try {
                    const skipToQueue = (action === 2);
                    const isQueue = action;
                    if (isQueue) {
                        await SpotifyClient.queue(id);
                        let exampleEl = undefined;
                        try {
                            exampleEl = document.querySelector(`[data-id='example-${id}']`);
                        }
                        catch (e) {
                            console.error(e);
                        }
                        if (!skipToQueue)
                            notifications.create({ 'title': '已添加到队列', 'content': exampleEl ? exampleEl.textContent : '', 'icon': 'fab fa-spotify' });
                        else
                            await SpotifyClient.skipToNext();
                    }
                    else {
                        let params = { device_id };
                        id.match("spotify:track:") ? params.uris = [id] : params.context_uri = id;
                        await SpotifyClient.play(params);
                        pulse(1);
                    }
                    return true;
                }
                catch (err) {
                    console.log(err);
                    return false;
                }
            }
        };
    });
    args.search.quickLaunch = 'l';
    args.playlist.quickLaunch = 'm';
    args.track.quickLaunch = 't';
    shortcuts.set('spotify', {
        background: process.env.SPOTIFY_COLOR,
        color: process.env.BACKGROUND_DARK,
        arguments: Object.assign(Object.assign({}, args), { podcast: {
                quickLaunch: 'n',
                description: '搜索播客',
                async callback(p, id, action) {
                    if (action === 1) {
                        selectedShowId = id;
                        const e = new CustomEvent('injectRoosterAction', { detail: { 'command': 'spotify', 'argument': 'podcast ->' } });
                        window.dispatchEvent(e);
                        document.getElementById('rooster-argument').dispatchEvent(new KeyboardEvent('keydown', { 'key': ' ' }));
                        return false;
                    }
                    const lastShow = await SpotifyClient.getShowEpisodes(id, { 'limit': 1 });
                    await SpotifyClient.play({ 'uris': [lastShow.items[0].uri], device_id });
                    return true;
                },
            }, 'podcast ->': {
                active: selectedShowId.length > 0,
                hideInModal: true,
                async callback(p, id, action) {
                    await SpotifyClient.play({ uris: [id], device_id });
                    return true;
                },
            }, pause: {
                description: '[或按空格键]',
                async callback() {
                    try {
                        await SpotifyClient.pause({ device_id });
                        return true;
                    }
                    catch (e) {
                        console.error(e);
                        return false;
                    }
                }
            }, queue: {
                description: '显示即将播放的曲目',
                async callback() {
                    return false;
                }
            } }),
        async examples(arg, params) {
            if (['search', 'album', 'playlist', 'track'].find(a => a === arg)) {
                //@ts-ignore
                return loadSearch(params, arg);
            }
            else if (arg === 'podcast') {
                //@ts-ignore
                return loadPodcastSearch(params);
            }
            else if (arg === 'podcast ->') {
                //@ts-ignore
                console.log(selectedShowId);
                return loadEpisodeSearch(params);
            }
            else if (arg.startsWith('qu')) {
                return loadQueue();
            }
            if (arg !== 'podcast ->') {
                selectedShowId = '';
            }
            return null;
        }
    });
}
